import React, {useEffect, useState} from 'react'
import styles from './LightningProtectionCalcConfigurator.styl'
import Image from './ui/features/Image.jsx'
import Button from './ui/button/Button.jsx'
import RadioGroup from './ui/features/RadioGroup/RadioGroup.jsx'
import Input from './ui/features/Input/Input.jsx'
import Popup from './ui/features/Popup/Popup.jsx'
import {PDFDownloadLink} from '@react-pdf/renderer'
import PDFLightCountReport from './ui/PDFCreation/PDFLightCountReport.js'
import TextAreaInput from './ui/features/TextArea/TextAreaInput.jsx'
import ImageInput from './ui/features/ImageInput/ImageInput.jsx'
import DropDown from './ui/features/DropDown/DropDown.jsx'
import GroundLightVersion from './ui/features/Version/GroundLightVersion.jsx'

const RELIAB_MIN 	= 0.9
const RELIAB_AVER = 0.99
const RELIAB_MAX 	= 0.999

const ONE_ROD = 'one_rod'
const TWO_ROD = 'two_rod'
const ONE_CABLE = 'one_cable'
const TWO_CABLE = 'two_cable'

const RECT = 'Прямоуголный'
const CONNECT = 'Сосредоточенный'

const mainBlockDefaultState = {
	type:RECT,
	td:'',
	ng:0,
	n:0,
}

const buildSizeDefaultState = {
	buildLength: '',
	buildWidth:'',
	buildHeight:'',
}


const oneRodDefaultState = {
	reliability:RELIAB_MIN,
	light:'',
	zoneHeight:'',
	radiusGround:'',
	radiusTop:'',
	strikeNum:'',
	hx:''
}
const twoRodDefaultState = {
	...oneRodDefaultState,
	l:'',
	lmax:'',
	sagHeight:'',
	lc:'',
	rcx: '', // Полуширина горизонтального сечения
	hc:'' // высота провеса
}
const oneCableDefaultState = {
	...oneRodDefaultState,
	distance:'',
}
const twoCableDefaultState = {
	...oneRodDefaultState,
	distanceSec:'',
	cableLength:'',
	lmax:'',
	sagHeight:'',
	lc:'',
}

const LightningProtectionCalcConfigurator = ({onNavConfigurator, onDocConfigurator}) =>{


	// ++ Стейты
	const [viewSec, setViewSec] = useState(ONE_ROD)
	const [showSize, setShowSize] = useState(true)
	const [reportEnable, setReport] = useState(false)
	const [warnText, setWarnText] = useState('')

	const [name, setName] = useState('')
	const [author, setAuthor] = useState('')
	const [address, setAddress] = useState('')
	const [desc, setDesc] = useState('')
	const [projectImg, setProjectImg] = useState('')

	const [mainState, setMainState] = useState({
		...twoCableDefaultState,
		...oneCableDefaultState,
		...twoRodDefaultState,
		...oneRodDefaultState,
		...mainBlockDefaultState,
		...buildSizeDefaultState,
	})

	// -- Стейты

	React.useEffect(() => {
		closeWarning()
	},[]);

	React.useEffect(() => {
		setState('buildWidth', '')
		setState('buildLength', '')
	},[showSize]);

// ++ Логика

	// ++ Ворнинг
	const closeWarning = () => {
		setWarnText('')
	}
	const showWarning = (warningText) =>{
		setWarnText(warningText)
	}
	const clickAwayHandler = (event) => {
			closeWarning()
	}

	// -- Ворнинг
	const setState = (propName, value) =>{
		setMainState((prevState) =>({...prevState, [propName]:value}))
	}

	const countOneRod = () => {
		const {reliability, light, hx} = mainState
		let h0, r0, rx
		switch (reliability) {
			case RELIAB_MIN:
				h0 = 0.85 * light
				r0 = light <= 100 ? light * 1.2 : light * (1.2 - ((light - 100) / 1000))
				break;
			case RELIAB_AVER:
				if (light > 0 && light <= 30) {
					h0 = 0.8 * light
					r0 = 0.8 * light
				} else if (light > 30 && light <= 100) {
					h0 = 0.8 * light
					r0 = light * (0.8 - (1.43 * (light - 30) / 1000))
				} else if (light > 100 && light <= 150) {
					h0 = light * (0.8 - ((light - 100) / 1000))
					r0 = 0.7 * light
				}
				break;
			case RELIAB_MAX:
				if (light > 0 && light <= 30) {
					h0 = 0.7 * light
					r0 = 0.6 * light
				} else if (light > 30 && light <= 100) {
					h0 = light * (0.7 - (7.14 * (light - 30) / 10000))
					r0 = light * (0.6 - (1.43 * (light - 30) / 1000))
				} else if (light > 100 && light <= 150) {
					h0 = light * (0.65 - ((light - 100) / 1000))
					r0 = light * (0.5 - (2 * (light - 100) / 1000))
				}
				break;
		}

		rx = r0 * (h0 - hx) / h0

		setMainState((prevState)  => ({
			...prevState,
			zoneHeight: h0.toFixed(2),
			radiusGround: r0.toFixed(2),
			radiusTop: rx.toFixed(2)
		}))

	}
	const countTwoRod = () => {
		const {reliability, light, hx, l} = mainState

		let lmax, lc, h0, r0, rx, rcx, hc
		switch (reliability) {
			case RELIAB_MIN:
				h0 = 0.85 * light
				r0 = light <= 100 ? light * 1.2 : light * (1.2 - ((light - 100) / 1000))
				if (light > 0 && light <= 30) {
					lmax = 5.75 * light
					lc = 2.5 * light
				} else if (light > 30 && light <= 100) {
					lmax = light * (5.75 - (3.75 * (light - 30) / 1000))
					lc = 2.5 * light
				} else if (light > 100 && light <= 150) {
					lmax = 5.5 * light
					lc = 2.5 * light
				}
				break;
			case RELIAB_AVER:
				if (light > 0 && light <= 30) {
					lmax = 4.75 * light
					lc = 2.25 * light
					h0 = 0.8 * light
					r0 = 0.8 * light
				} else if (light > 30 && light <= 100) {
					lmax = light * (4.75 - (3.57 * (light - 30) / 1000))
					lc = light * (5.75 - (2.25 * 0.01007 * (light - 30)))
					h0 = 0.8 * light
					r0 = light * (0.8 - (1.43 * (light - 30) / 1000))
				} else if (light > 100 && light <= 150) {
					lmax = 4.5 * light
					lc = 1.5 * light
					h0 = light * (0.8 - ((light - 100) / 1000))
					r0 = 0.7 * light
				}
				break;
			case RELIAB_MAX:
				if (light > 0 && light <= 30) {
					lmax = 4.25 * light
					lc = 2.25 * light
					h0 = 0.7 * light
					r0 = 0.6 * light
				} else if (light > 30 && light <= 100) {
					lmax = light * (4.75 - (3.57 * (light - 30) / 1000))
					lc = light * (5.75 - (2.25 * 0.01007 * (light - 30)))
					h0 = light * (0.7 - (7.14 * (light - 30) / 10000))
					r0 = light * (0.6 - (1.43 * (light - 30) / 1000))
				} else if (light > 100 && light <= 150) {
					lmax = 4 * light
					lc = 1.5 * light
					h0 = light * (0.65 - ((light - 100) / 1000))
					r0 = light * (0.5 - (2 * (light - 100) / 1000))
				}
				break;
		}

		rx = r0 * (h0 - hx) / h0
		hc = l < lc ? h0 : h0*(lmax - l)/(lmax - lc)
		rcx = r0 * (hc - hx) / hc

		setMainState((prevState) => ({
			...prevState,
			lc,
			lmax: lmax.toFixed(2),
			zoneHeight: h0.toFixed(2),
			radiusGround: r0.toFixed(2),
			radiusTop: rx.toFixed(2),
			hc: hc.toFixed(2),
			rcx: rcx.toFixed(2)
		}))

	}
	const countOneCable = () => {

		const {reliability, light, hx} = mainState

		let h0, r0, rx
		switch (reliability) {
			case RELIAB_MIN:
				h0 = 0.87 * light
				r0 = 1.5 * light
				break;
			case RELIAB_AVER:
				if (light > 0 && light <= 30) {
					h0 = 0.8 * light
					r0 = 0.95 * light
				} else if (light > 30 && light <= 100) {
					h0 = 0.8 * light
					r0 = light * (0.95 - (7.14 * (light - 30) / 10000))
				} else if (light > 100 && light <= 150) {
					h0 = 0.8 * light
					r0 = light * (0.9 - ((light - 100) / 1000))
				}
				break;
			case RELIAB_MAX:
				if (light > 0 && light <= 30) {
					h0 = 0.75 * light
					r0 = 0.7 * light
				} else if (light > 30 && light <= 100) {
					h0 = light * (0.75 - (4.28 * (light - 30) / 10000))
					r0 = light * (0.7 - (1.43 * (light - 30) / 1000))
				} else if (light > 100 && light <= 150) {
					h0 = light * (0.72 - ((light - 100) / 1000))
					r0 = light * (0.6 - ((light - 100) / 1000))
				}
				break;
		}
		rx = r0 * (h0 - hx) / h0

		setMainState((prevState) => ({
			...prevState,
			zoneHeight: h0.toFixed(2),
			radiusGround: r0.toFixed(2),
			radiusTop: rx.toFixed(2),
		}))

	}
	const countTwoCable = () => {

		const {reliability, light, hx, distanceSec} = mainState

		let lmax, lc, hc, h0, r0, rx, lx, rcx
		switch (reliability) {
			case RELIAB_MIN:
				h0 = 0.87 * light
				r0 = 1.5 * light
				lmax = 6 * light
				lc = 3 * light
				break;
			case RELIAB_AVER:
				if (light > 0 && light <= 30) {
					lmax = 5 * light
					lc = 2.5 * light
					h0 = 0.8 * light
					r0 = 0.95 * light
				} else if (light > 30 && light <= 100) {
					lmax = 5 * light
					lc = light * (2.5 - (7.14 * (light - 30) / 1000))
					h0 = 0.8 * light
					r0 = light * (0.95 - (7.14 * (light - 30) / 10000))
				} else if (light > 100 && light <= 150) {
					lmax = light * (0.5 - (5 * (light - 100) / 1000))
					lc = light * (2 - (5 * (light - 100) / 1000))
					h0 = 0.8 * light
					r0 = light * (0.9 - ((light - 100) / 1000))
				}
				break;
			case RELIAB_MAX:
				if (light > 0 && light <= 30) {
					lmax = 4.75 * light
					lc = 2.25 * light
					h0 = 0.75 * light
					r0 = 0.7 * light
				} else if (light > 30 && light <= 100) {
					lmax = light * (4.75 - (3.57 * (light - 30) / 1000))
					lc = light * (2.25 - (3.57 * (light - 30) / 1000))
					h0 = light * (0.75 - (4.28 * (light - 30) / 10000))
					r0 = light * (0.7 - (1.43 * (light - 30) / 1000))
				} else if (light > 100 && light <= 150) {
					lmax = light * (4.5 - (5 * (light - 100) / 1000))
					lc = light * (2 - (5 * (light - 100) / 1000))
					h0 = light * (0.72 - ((light - 100) / 1000))
					r0 = light * (0.6 - ((light - 100) / 1000))
				}
				break;
		}

		hc = distanceSec < lc ? h0 : h0 * (lmax - distanceSec) / (lmax - lc)
		rx = r0 * (h0 - hx) / h0
		lx = distanceSec * (h0 - hx) / (2 * (h0 - hc))
		rcx = r0 * (hc - hx) / hc

		setMainState((prevState) => ({
			...prevState,
			lc,
			lmax: lmax.toFixed(2),
			zoneHeight: h0.toFixed(2),
			sagHeight: hc.toFixed(2),
			radiusGround: r0.toFixed(2),
			radiusTop: rx.toFixed(2),
			rcx: rcx.toFixed(2)
		}))

	}
	const countStrikeNum = () => {
		const {td, buildHeight, buildLength, buildWidth, type} = mainState

		const ng = 6.7 * td/100

		const n = type === RECT
			? ((buildWidth + 6 * buildHeight)*(buildLength + 6 * buildHeight) - 7.7 * buildHeight * buildHeight) * ng / 1000000
			: 9 * Math.PI * buildHeight * buildHeight * ng / 1000000

		setMainState((prevState) => ({
			...prevState,
			ng:+String(ng.toFixed(4)),
			n:+String(n.toFixed(4))
		}))

	}


	const getObj = () => {
		switch (viewSec) {
			case ONE_ROD:
				return oneRodDefaultState
			case TWO_ROD:
				return twoRodDefaultState
			case ONE_CABLE:
				return oneCableDefaultState
			case TWO_CABLE:
				return twoCableDefaultState
		}
	}

	const getValueBeforeBlur = (value, fieldName) => {
		// const obj = getObj()
		// if(value <= 0){
		// 	showWarning('Введите значение больше 0')
		// 	return obj[fieldName]
		// }
		return value
	}

// -- Логика

// ++ Обработка событий
// ++ Радиобаттоны

	const onReliabilityChange = (event) =>{
		setState('reliability', Number(event.target.value))
	}

	useEffect(()=>{
		cont()
	}, [mainState.reliability])

	useEffect(()=>{
		if(mainState.type === RECT){
			setState('n', 0)
			setState('ng', 0)
		}else{
			cont()
		}
	}, [mainState.type])

// -- Радиобаттоны

// ++ Инпуты

	const onTDChange = (event) => {
		setState('td', Number(event.target.value))
	}
	const onTDBlur = (event) => {
		const value = getValueBeforeBlur(Number(event.target.value), 'td')
		setState('td', value)
		cont()
	}

	const onLengthChange = (event) => {
		setState('buildLength', Number(event.target.value))
	}
	const onLengthBlur = (event) => {
		const value = getValueBeforeBlur(Number(event.target.value), 'buildLength')
		setState('buildLength', value)
		cont()
	}

	const onWidthChange = (event) => {
		setState('buildWidth', Number(event.target.value))
	}
	const onWidthBlur = (event) => {
		const value = getValueBeforeBlur(Number(event.target.value), 'buildWidth')
		setState('buildWidth', value)
		cont()
	}

	const onHeightChange = (event) => {
		setState('buildHeight', Number(event.target.value))
	}
	const onHeightBlur = (event) => {
		let value = getValueBeforeBlur(Number(event.target.value), 'buildHeight')
		setState('buildHeight', value)
		cont()
	}

	const onLightChange = (event) => {
		setState('light', Number(event.target.value))
	}
	const onLightBlur = (event) => {
		let value = getValueBeforeBlur(Number(event.target.value), 'light')
		setState('light', value)
		cont()
	}

	const onHxChange = (event) => {
		setState('hx', Number(event.target.value))
	}
	const onHxBlur = (event) => {
		let value = getValueBeforeBlur(Number(event.target.value), 'hx')
		setState('hx', value)
		cont()
	}

	const onLChange= (event) => {
		setState('l', Number(event.target.value))
	}

	const onLBlur = (event) => {
		let value = getValueBeforeBlur(Number(event.target.value), 'l')
		setState('l', value)
		cont()
	}

	const onDistanceSecChange = (event) => {
		setState('distanceSec', Number(event.target.value))
	}
	const onDistanceSecBlur = (event) => {
		const value = getValueBeforeBlur(Number(event.target.value), 'distanceSec')
		setState('distanceSec', value)
		cont()
	}

// -- Инпуты

// ++ Дропдауны

	const onTypeChange = (event) => {
		setShowSize(event.target.value === RECT)
		setState('type', event.target.value)
	}

// -- Дропдауны


// ++ Данные объекта

	const onNameChange = (event) => {
		setName(event.target.value)
	}
	const onAuthorChange = (event) => {
		setAuthor(event.target.value)
	}
	const onAddressChange = (event) => {
		setAddress(event.target.value)
	}
	const onDescChange = (event) => {
		setDesc(event.target.value)
	}
	const onProjectImgChange = (event) => {
		const fReader = new FileReader();
		fReader.readAsDataURL(event.target.files[0]);
		fReader.onloadend = (e) =>{
			setProjectImg(e.target.result)
		}
	}

// -- Данные объекта

// ++ Кнопки
	const cont = () =>{
		const {buildLength, buildWidth, buildHeight, light, distanceSec, td, type, hx, l} = mainState
		let allowCountLight = type === RECT
			? buildLength && buildWidth && buildHeight && td
			: buildHeight && td
		allowCountLight ?  countStrikeNum() : setReport(false)
		switch (viewSec) {
			case ONE_ROD:
				if(light && hx){
					countOneRod()
					setReport(allowCountLight && true)
				}
				break;
			case TWO_ROD:
				if(light && hx && l){
					countTwoRod()
					setReport(allowCountLight && true)
				}
				break;
			case ONE_CABLE:
				if(light && hx){
					countOneCable()
					setReport(allowCountLight && true)
				}
				break;
			case TWO_CABLE:
				if(light && distanceSec && hx){
					countTwoCable()
					setReport(allowCountLight && true)
				}
				break;
		}
	}
	const onBtnClearClick = () =>{
		switch (viewSec) {
			case ONE_ROD:
				setMainState({...mainState, ...oneRodDefaultState})
				break;
			case TWO_ROD:
				setMainState({...mainState, ...twoRodDefaultState})
				break;
			case ONE_CABLE:
				setMainState({...mainState, ...oneCableDefaultState})
				break;
			case TWO_CABLE:
				setMainState({...mainState, ...twoCableDefaultState})
				break;
		}

		setReport(false)
	}
	const onBtnBackClick = () => {onNavConfigurator()}
	const onToDoc = () => {onDocConfigurator()}
	const onBtnSaveClick = () => {
		if (!reportEnable) {
			showWarning('Перед формирование отчета расчитайте параметры молниезащиты')
		}
	}


// -- Кнопки

// -- Обработка событий

// ++ Отрисовка


// ++ Доп компоненты
const getResultStr = ({top, left, str, result, key, maxWidth='500px'}) =>{

		return (<div className={styles.smallText}
								 key={key}
								 style={{
									 position: 'absolute',
									 top:`${top}px`,
									 left:`${left}px`,
									 lineHeight:'1.2rem',
									 maxWidth
								 }}>
			<span
				style={{
					marginRight: '10px'
				}}
			>{str}</span>
			{result ?
				<span
					style={{
						fontWeight: 'bold'
					}}>{result}</span> :
				null
			}

		</div>)

	}
// -- Доп компоненты

// ++ Кнопки
	const getCustomButtons = () => {

		let elements = [];

		elements.push(
			<Button
				x="20"
				y="725"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сброс"
				onClick={onBtnClearClick}
				key="clear"
			/>
		);
		// деструктуризировать
		reportEnable ?
			elements.push(
				<PDFDownloadLink key={'pdf'} document={<PDFLightCountReport
					viewSec={viewSec}
					reliability={mainState.reliability}
					buildLength={mainState.buildLength}
					buildWidth={mainState.buildWidth}
					buildHeight={mainState.buildHeight}
					light={mainState.light}
					zoneHeight={mainState.zoneHeight}
					radiusGround={mainState.radiusGround}
					radiusTop={mainState.radiusTop}
					l={mainState.l}
					rcx={mainState.rcx}
					lmax={mainState.lmax}
					sagHeight={mainState.sagHeight}
					distance={mainState.distance}
					distanceSec={mainState.distanceSec}
					cableLength={mainState.cableLength}
					hx={mainState.hx}
					hc={mainState.hc}
					Lc={mainState.lc}
					td={mainState.td}
					n={mainState.n}
					ng={mainState.ng}
					type={mainState.type}
					name={name}
					address={address}
					desc={desc}
					author={author}
					imgData={projectImg}
					date={new Date().toLocaleDateString()}
				/>} fileName="Отчет.pdf"
												 style={{
													 position: 'absolute',
													 top:'725px',
													 left:'250px',
												 }}>

					<div className={styles.mainBtn} title={'Сохранить отчет'}>
						{styles.pdfBtnIcon &&
							<div className={styles.pdfBtnIcon}></div>
						}
						<span className={styles.mainBtnText}>{'Сохранить отчет'}</span>
					</div>
				</PDFDownloadLink>
			)
			:
			elements.push(<Button
				x="250"
				y="725"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить отчет"
				onClick={onBtnSaveClick}
				key="emptyPdf"
			/>)

		elements.push(
			<Button
				x="480"
				y="725"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Главное меню"
				onClick={onBtnBackClick}
				key="backToNav"
			/>
		);

		elements.push(
			<Button
				x="1120"
				y="725"
				buttonStyle={styles.buttonDoc}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Нормативно-техническая документация"
				onClick={onToDoc}
				key="doc"
			/>
		);

		return elements
	}
// -- Кнопки
	// ++ Контент

	const mainBlock = () =>{
		let elements = [];

		elements.push(<DropDown
			x={360}
			y={100}
			title='Тип здания:'
			key={'main' + elements.length}
			onChange={onTypeChange}
			value={mainState.type}
			options={[RECT, CONNECT]}
		/>)

		elements.push(<Input
			key={'main' + elements.length}
			x={360}
			y={150}
			width={140}
			title='Среднегодовая продолжительность гроз, ч, (Td):'
			type = 'number'
			min={0}
			max={999}
			step={0.1}
			onChange={onTDChange}
			onBlur={onTDBlur}
			value={mainState.td}
		/>)

		elements.push(<Input
			key={'main' + elements.length}
			x={540}
			y={100}
			width={80}
			title='Высота здания, м, (Hmax):'
			type = 'number'
			min={1}
			max={999}
			step={0.01}
			onChange={onHeightChange}
			onBlur={onHeightBlur}
			value={mainState.buildHeight}
		/>)
		if(showSize){
			elements.push(<Input
				key={'main' + elements.length}
				x={720}
				y={100}
				labelWidth={120}
				width={80}
				title='Длина здания, м, (l):'
				type = 'number'
				min={1}
				max={999}
				step={0.01}
				onChange={onLengthChange}
				onBlur={onLengthBlur}
				value={mainState.buildLength}
			/>)

			elements.push(<Input
				key={'main' + elements.length}
				x={875}
				y={100}
				labelWidth={130}
				width={80}
				title='Ширина здания, м, (b):'
				type = 'number'
				min={1}
				max={999}
				step={0.01}
				onChange={onWidthChange}
				onBlur={onWidthBlur}
				value={mainState.buildWidth}
			/>)
		}

		elements.push(getResultStr({
			top:210,
			left:360,
			str:'Количество поражений молнией в год, шт, (N):',
			result:mainState.n,
			key:'main' + elements.length
		}))


		return elements

	}

	const countResultBlock = () =>{
		switch (viewSec) {
			case ONE_ROD:
				return oneRodBlock()
			case TWO_ROD:
				return twoRodBlock()
			case ONE_CABLE:
				return oneCableBlock()
			case TWO_CABLE:
				return twoCableBlock()
		}
	}

	const oneRodBlock = () => {
		let elements = [];

		elements.push(<div key={'oneRod' + elements.length} className={styles.sectionTitle}
											 style={{top: '20px', left: '45%'}}>Расчет</div>)

		elements.push(<div key={'oneRod' + elements.length} className={styles.sectionHeader}
											 style={{top: '45px', left: '20px'}}>Надежность защиты от ПУМ:</div>)

		elements.push(<RadioGroup
			key={'oneRod' + elements.length}
			type='reliabilityOneRod'
			x={20}
			y={75}
			options={[RELIAB_MIN, RELIAB_AVER, RELIAB_MAX]}
			value={mainState.reliability}
			labelWidth={50}
			onChange={onReliabilityChange}
		/>)

		elements.push(<Input
			key={'oneRod' + elements.length}
			x={350}
			y={43}
			labelWidth={140}
			width={80}
			title='Высота молниеотвода, м, (h, <150):'
			type = 'number'
			min={1}
			max={999}
			step={0.01}
			onChange={onLightChange}
			onBlur={onLightBlur}
			value={mainState.light}
		/>)

		elements.push(<Input
			key={'oneRod' + elements.length}
			x={550}
			y={55}
			width={80}
			title='Высота защищаемого объекта, м, (hx):'
			type = 'number'
			min={1}
			max={999}
			step={0.01}
			onChange={onHxChange}
			onBlur={onHxBlur}
			value={mainState.hx}
		/>)

		elements.push(<hr
			key={'oneRod' + elements.length}
				style={{
					position:'absolute',
					left:'20px',
					top:'110px',
					background:'#535353',
					width:'920px',
					height:'3px'
			}}
		/>)

		elements.push(<div key={'oneRod' + elements.length} className={styles.sectionTitle}
											 style={{top: '140px', left: '44%'}}>Результат</div>)

		elements.push(getResultStr({
			top:180,
			left:20,
			str:'Высота зоны, м, (h0):',
			result:mainState.zoneHeight,
			key:'oneRod' + elements.length
		}))

		elements.push(getResultStr({
			top:230,
			left:20,
			str:'Радиус зоны на уровне земли, м, (r0):',
			result:mainState.radiusGround,
			key:'oneRod' + elements.length
		}))

		elements.push(getResultStr({
			top:280,
			left:20,
			str:'Радиус зоны на уровне высоты hx, м, (rx):',
			result:mainState.radiusTop,
			key:'oneRod' + elements.length
		}))

		return elements
	}
	const twoRodBlock = () => {

		let elements = [];

		elements.push(<div key={'twoRod' + elements.length} className={styles.sectionTitle}
											 style={{top: '20px', left: '45%'}}>Расчет</div>)

		elements.push(<div key={'twoRod' + elements.length} className={styles.sectionHeader}
											 style={{top: '45px', left: '20px'}}>Надежность защиты от ПУМ:</div>)

		elements.push(<RadioGroup
			key={'twoRod' + elements.length}
			type='reliabilityTwoRod'
			x={20}
			y={75}
			options={[RELIAB_MIN, RELIAB_AVER, RELIAB_MAX]}
			value={mainState.reliability}
			labelWidth={50}
			onChange={onReliabilityChange}
		/>)


		elements.push(<Input
			key={'twoRod' + elements.length}
			x={350}
			y={43}
			labelWidth={140}
			width={80}
			title='Высота молниеотвода, м, (h, <150):'
			type = 'number'
			min={1}
			max={999}
			step={0.01}
			onChange={onLightChange}
			onBlur={onLightBlur}
			value={mainState.light}
		/>)

		elements.push(<Input
			key={'twoRod' + elements.length}
			x={550}
			y={43}
			width={80}
			labelWidth={140}
			title='Высота защищаемого объекта, м, (hx):'
			type = 'number'
			min={1}
			max={999}
			step={0.01}
			onChange={onHxChange}
			onBlur={onHxBlur}
			value={mainState.hx}
		/>)

		elements.push(<Input
			key={'twoRod' + elements.length}
			x={750}
			y={43}
			width={80}
			labelWidth={200}
			title='Расстояние между стержневыми молниеприемниками, м, (L):'
			type = 'number'
			min={1}
			max={999}
			step={0.01}
			onChange={onLChange}
			onBlur={onLBlur}
			value={mainState.l}
		/>)

		elements.push(<hr
			key={'twoRod' + elements.length}
			style={{
				position:'absolute',
				left:'20px',
				top:'110px',
				background:'#535353',
				width:'920px',
				height:'3px'
			}}
		/>)

		elements.push(<div key={'twoRod' + elements.length} className={styles.sectionTitle}
											 style={{top: '140px', left: '44%'}}>Результат</div>)

		elements.push(getResultStr({
			top:180,
			left:20,
			maxWidth:'600px',
			str:'Предельное расстояние между стержневыми молниеприемниками, м, (Lmax):',
			result:mainState.lmax,
			key:'twoRod' + elements.length
		}))

		elements.push(getResultStr({
			top:210,
			left:20,
			str:'Высота зоны, м, (h0):',
			result:mainState.zoneHeight,
			key:'twoRod' + elements.length
		}))

		elements.push(getResultStr({
			top:240,
			left:20,
			str:'Радиус зоны на уровне земли, м (r0):',
			result:mainState.radiusGround,
			key:'twoRod' + elements.length
		}))

		elements.push(getResultStr({
			top:270,
			left:20,
			str:'Радиус зоны на уровне высоты hx, м, (rx):',
			result:mainState.radiusTop,
			key:'twoRod' + elements.length
		}))

		elements.push(getResultStr({
			top:300,
			left:20,
			str:'Высота провеса, м, (hc):',
			result:mainState.hc,
			key:'twoRod' + elements.length
		}))

		elements.push(getResultStr({
			top:330,
			left:20,
			str:'Полуширина горизонтального сечения, м, (rcx):',
			result:mainState.rcx,
			key:'twoRod' + elements.length
		}))


		return elements
	}
	const oneCableBlock = () => {
		let elements = [];

		elements.push(<div key={'oneCable' + elements.length} className={styles.sectionTitle}
											 style={{top: '20px', left: '45%'}}>Расчет</div>)

		elements.push(<div key={'oneCable' + elements.length} className={styles.sectionHeader}
											 style={{top: '45px', left: '20px'}}>Надежность защиты от ПУМ:</div>)

		elements.push(<RadioGroup
			key={'oneCable' + elements.length}
			type='reliabilityOneCable'
			x={20}
			y={75}
			labelWidth={50}
			options={[RELIAB_MIN, RELIAB_AVER, RELIAB_MAX]}
			value={mainState.reliability}
			onChange={onReliabilityChange}
		/>)

		elements.push(<Input
			key={'oneCable' + elements.length}
			x={350}
			y={43}
			labelWidth={140}
			width={80}
			title='Высота молниеотвода, м, (h, <150):'
			type = 'number'
			min={1}
			max={999}
			step={0.01}
			onChange={onLightChange}
			onBlur={onLightBlur}
			value={mainState.light}
		/>)

		elements.push(<Input
			key={'oneRod' + elements.length}
			x={550}
			y={55}
			width={80}
			title='Высота защищаемого объекта, м, (hx):'
			type = 'number'
			min={1}
			max={999}
			step={0.01}
			onChange={onHxChange}
			onBlur={onHxBlur}
			value={mainState.hx}
		/>)


		elements.push(<hr
			key={'oneCable' + elements.length}
			style={{
				position:'absolute',
				left:'20px',
				top:'110px',
				background:'#535353',
				width:'920px',
				height:'3px'
			}}
		/>)

		elements.push(<div key={'oneCable' + elements.length} className={styles.sectionTitle}
											 style={{top: '140px', left: '44%'}}>Результат</div>)


		elements.push(getResultStr({
			top:180,
			left:20,
			str:'Высота зоны, м, (h):',
			result:mainState.zoneHeight,
			key:'oneCable' + elements.length
		}))

		elements.push(getResultStr({
			top:230,
			left:20,
			str:'Радиус зоны на уровне земли, м, (r0):',
			result:mainState.radiusGround,
			key:'oneCable' + elements.length
		}))

		elements.push(getResultStr({
			top:280,
			left:20,
			str:'Радиус зоны на уровне высоты hx, м, (rx):',
			result:mainState.radiusTop,
			key:'radiusTop' + elements.length
		}))

		return elements
	}
	const twoCableBlock = () => {
		let elements = [];

		elements.push(<div key={'twoCable' + elements.length} className={styles.sectionTitle}
											 style={{top: '20px', left: '45%'}}>Расчет</div>)

		elements.push(<div key={'twoCable' + elements.length} className={styles.sectionHeader}
											 style={{top: '45px', left: '20px'}}>Надежность защиты от ПУМ:</div>)

		elements.push(<RadioGroup
			key={'twoCable' + elements.length}
			type='reliabilityTwoRod'
			x={20}
			y={75}
			options={[RELIAB_MIN, RELIAB_AVER, RELIAB_MAX]}
			value={mainState.reliability}
			labelWidth={50}
			onChange={onReliabilityChange}
		/>)

		elements.push(<Input
			key={'twoCable' + elements.length}
			x={350}
			y={43}
			labelWidth={145}
			width={80}
			title='Высота молниеотвода, м, (h, <150):'
			type = 'number'
			min={1}
			max={999}
			step={0.01}
			onChange={onLightChange}
			onBlur={onLightBlur}
			value={mainState.light}
		/>)

		elements.push(<Input
			key={'twoCable' + elements.length}
			x={550}
			y={43}
			labelWidth={145}
			width={80}
			title='Расстояние до второго молниеотвода, м, (S):'
			type = 'number'
			min={1}
			max={999}
			step={0.01}
			onChange={onDistanceSecChange}
			onBlur={onDistanceSecBlur}
			value={mainState.distanceSec}
		/>)

		elements.push(<Input
			key={'oneRod' + elements.length}
			x={750}
			y={43}
			width={80}
			title='Высота защищаемого объекта, м, (hx):'
			type = 'number'
			min={1}
			max={999}
			step={0.01}
			onChange={onHxChange}
			onBlur={onHxBlur}
			value={mainState.hx}
		/>)

		elements.push(<hr
			key={'twoCable' + elements.length}
			style={{
				position:'absolute',
				left:'20px',
				top:'110px',
				background:'#535353',
				width:'920px',
				height:'3px'
			}}
		/>)

		elements.push(<div key={'twoCable' + elements.length} className={styles.sectionTitle}
											 style={{top: '140px', left: '44%'}}>Результат</div>)

		elements.push(getResultStr({
			top:180,
			left:20,
			maxWidth:'600px',
			str:'Предельное расстояние между стержневыми молниеприемниками, м, (Lmax):',
			result:mainState.lmax,
			key:'twoCable' + elements.length
		}))

		elements.push(getResultStr({
			top:210,
			left:20,
			str:'Высота зоны, м, (h0):',
			result:mainState.zoneHeight,
			key:'twoCable' + elements.length
		}))

		elements.push(getResultStr({
			top:240,
			left:20,
			str:'Высота провеса, м, (hc):',
			result:mainState.sagHeight,
			key:'twoCable' + elements.length
		}))

		elements.push(getResultStr({
			top:270,
			left:20,
			str:'Радиус зоны на уровне земли, м, (r0):',
			result:mainState.radiusGround,
			key:'twoCable' + elements.length
		}))

		elements.push(getResultStr({
			top:300,
			left:20,
			str:'Полуширина горизонтального сечения, м, (rcx):',
			result:mainState.radiusTop,
			key:'twoCable' + elements.length
		}))

		return elements
	}
	const infoInput = () => {
		let elements = [];

		elements.push(<TextAreaInput
			key={'info' + elements.length}
			x={20}
			y={10}
			width={270}
			rows={2}
			title='Название объекта'
			onChange={onNameChange}
			disabled={false}
			value={name}
		/>)

		elements.push(<Input
			key={'info' + elements.length}
			x={20}
			y={90}
			width={270}
			title='Автор проекта'
			onChange={onAuthorChange}
			disabled={false}
			value={author}
		/>)

		elements.push(<TextAreaInput
			key={'info' + elements.length}
			x={20}
			y={140}
			width={270}
			rows={2}
			title='Адрес объекта'
			onChange={onAddressChange}
			disabled={false}
			value={address}
		/>)

		elements.push(<ImageInput
			key={'info' + elements.length}
			title={'Выберите изображение объекта (.jpg, .jpeg, .png)'}
			x={20}
			y={220}
			onChange={onProjectImgChange}
			onInput={onProjectImgChange}
		/>)

		elements.push(<TextAreaInput
			key={'info' + elements.length}
			x={20}
			y={270}
			width={270}
			title='Описание'
			onChange={onDescChange}
			disabled={false}
			value={desc}
		/>)

		elements.push(
			<div style={{
				top: '400px',
				width: '140px'
			}}
					 key={'info' + elements.length}
					 className={styles.selectBlank}
			/>
		)

		return elements
	}
	// -- Контент

// -- Отрисовка
	// переделать
	let oneRodBGColor = '#fff'
	let twoRodBGColor = '#dcdcdc'
	let oneCableBGColor = '#dcdcdc'
	let twoCableBGColor = '#dcdcdc'
	let imgStyle = styles.imgBase


	switch (viewSec) {
		case ONE_ROD:
			oneRodBGColor = '#fff'
			twoRodBGColor = '#dcdcdc'
			oneCableBGColor = '#dcdcdc'
			twoCableBGColor = '#dcdcdc'
			imgStyle = styles.osm
			break;
		case TWO_ROD:
			oneRodBGColor = '#dcdcdc'
			twoRodBGColor = '#fff'
			oneCableBGColor = '#dcdcdc'
			twoCableBGColor = '#dcdcdc'
			imgStyle = styles.dsm
			break;
		case ONE_CABLE:
			oneRodBGColor = '#dcdcdc'
			twoRodBGColor = '#dcdcdc'
			oneCableBGColor = '#fff'
			twoCableBGColor = '#dcdcdc'
			imgStyle = styles.otm
			break;
		case TWO_CABLE:
			oneRodBGColor = '#dcdcdc'
			twoRodBGColor = '#dcdcdc'
			oneCableBGColor = '#dcdcdc'
			twoCableBGColor = '#fff'
			imgStyle = styles.dtm
			break;
	}

	return (<div className={styles.cfg}>

		{/*Белый фон и лого*/}
		<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '13%', height: '80px'}}/>

		{
			warnText
				?
				<Popup
					warningText={warnText}
					onClick={clickAwayHandler}
				/>
				:
				null

		}



		<Image
			className={styles.logo}
			blockChangeScale={true}
		/>
		{/*Оранжевый фон заголовка*/}
		<div style={{margin: '0 auto', backgroundColor: '#ffcc3f', width: '100%', height: '80px'}}>
			<div className={styles.title}>Расчет молниезащиты</div>
		</div>

		<div>

			<div style={{
				position:'relative',
				left: '20px',
				top: '20px',
				width: '320px',
				height: '40px',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: '#fff',
			}}>
				<div className={styles.sectionTitle}
						 style={{
							 position: 'absolute',
							 margin: '0 auto',
							 top:'20px',
							 textAlign: 'center',
							 width: '320px',
						 }}>
							<span style ={{
								minWidth:'300px',
							}}>
								Данные объекта
							</span>
				</div>
			</div>

			<div style={{
				position: 'absolute',
				margin: '0 auto',
				backgroundColor: '#fff',
				width: '320px',
				height: '300px',
				top:'140px',
				left:'20px',
				overflowY:'scroll'
			}}>
				{infoInput()}
			</div>

		</div>

		<Image
			className={[imgStyle]}
			blockChangeScale={false}
		/>


		<div
			style={{
				position: 'absolute',
				left: '1025px',
				top: '110px',
				height: '20px',
				fontSize:'14px'
			}}
		>Среднегодовая продолжительность гроз в часах, определенная по региональным картам:
		</div>

		<Image
			className={styles.table_img}
			blockChangeScale={false}
		/>


		{mainBlock()}

		<div
			style={{
				position: 'absolute',
				left: '360px',
				top: '260px',
				height: '20px'
			}}
			className={styles.title}
		>Молниеотвод:
		</div>
		{/*Табы для переключения видом*/}
		<div
			key={'view'}
			style={{position: 'absolute', top: '300px', left: "360px"}}>
					<span
						onClick={() => {
							setReport(false)
							setViewSec(ONE_ROD);
							setMainState({...mainState, ...oneRodDefaultState});
						}}
						style={{background: oneRodBGColor, cursor: 'pointer'}}
						className={styles.oneRodTitle + ' ' + 'activeTab'}>Одиночный стержневой</span>
			<span
				onClick={() => {
					setReport(false)
					setViewSec(TWO_ROD);
					setMainState({...mainState, ...twoRodDefaultState});
				}}
				style={{background: twoRodBGColor, cursor: 'pointer'}}
				className={styles.twoRodTitle + ' ' + 'activeTab'}>Двойной стержневой</span>
			<span
				onClick={() => {
					setReport(false)
					setViewSec(ONE_CABLE);
					setMainState({...mainState, ...oneCableDefaultState});
				}}
				style={{background: oneCableBGColor, cursor: 'pointer'}}
				className={styles.oneCableTitle + ' ' + 'activeTab'}>Одиночный троссовый</span>
			<span
				onClick={() => {
					setReport(false)
					setViewSec(TWO_CABLE);
					setMainState({...mainState, ...twoCableDefaultState});
				}}
				style={{background: twoCableBGColor, cursor: 'pointer'}}
				className={styles.twoCableTitle + ' ' + 'activeTab'}>Двойной троссовый</span>
		</div>

		<div style={{
			position: 'absolute',
			top: '340px',
			left: "360px",
			width: '960px',
			height: '365px',
			backgroundColor: '#fff'
		}}>

			{countResultBlock()}

		</div>


		{/*Кнопки*/}
		{getCustomButtons()}

		{/*Нижняя плашка*/}
		{/* На основной сайт IEK */}
		<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top: '780px'}}/>
		<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>
		<span className={styles.feedBack}>Почта для связи: kiselevav@iek.ru</span>
		<div style={{
			position: 'absolute',
			top: '785px',
			left: '1295px',
			zIndex: '15'
		}}>
			<GroundLightVersion />
		</div>

		{/* Техническая поддержка */}
		<div style={{
			position: 'absolute',
			backgroundColor: '#ffcc3f',
			width: '50%',
			height: '20px',
			top: '780px',
			left: '50%'
		}}/>
		<a style={{
			position: 'absolute',
			top: '783px',
			left: '395px',
			color: '#3c4e50',
			width: '141px',
			height: '14px'
		}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
		</a>
		<span className={styles.techSupport}>+7 (495) 542-22-27</span>

	</div>)
}

export default LightningProtectionCalcConfigurator



// WEBPACK FOOTER //
// ./src/react/LightningProtectionCalcConfigurator.jsx